import type { PartSvgProps } from './types'

export default function LowerReceiverSvg ({
  fill = 'var(--gs-part-fill,   #2A2A3A)',
  stroke = 'var(--gs-part-stroke, #5A6A7A)',
  accent = 'var(--gs-part-accent, #E85D04)',
  width = 160,
  height = 100
}: PartSvgProps) {
  return (
    <svg viewBox="0 0 160 100" width={width} height={height} fill="none"
         xmlns="http://www.w3.org/2000/svg">
      {/* Main lower body */}
      <path d="M 10 14 L 150 14 L 154 24 L 154 70 L 140 78 L 90 78 L 78 90 L 52 90 L 40 78 L 10 78 L 6 70 L 6 24 Z"
            fill={fill} stroke={stroke} strokeWidth="1.5" />
      {/* Magazine well opening */}
      <rect x="48" y="60" width="48" height="30" rx="2"
            fill="none" stroke={accent} strokeWidth="1.2" />
      {/* Trigger guard arc */}
      <path d="M 52 78 Q 72 96 92 78" fill="none" stroke={stroke} strokeWidth="1.2" />
      {/* Pistol grip socket (bottom rear) */}
      <rect x="118" y="68" width="22" height="22" rx="3"
            fill="none" stroke={stroke} strokeWidth="1" />
      {/* Buffer tube socket (rear) */}
      <rect x="140" y="22" width="14" height="24" rx="4"
            fill={fill} stroke={stroke} strokeWidth="1" />
      {/* Safety selector hole */}
      <circle cx="80" cy="40" r="5" fill="none" stroke={accent} strokeWidth="1" />
    </svg>
  )
}
